import { FC } from 'react';
import { Box } from '@mui/material';
import classnames from 'classnames';

import { ICardWithShadowProps } from './CardWithShadow.interface';

import './style.scss';

const CardWithShadow: FC<ICardWithShadowProps> = ({
  children,
  className,
  borderType = 'solid',
}) => {
  const cardClasses = classnames(
    { [`${className}`]: !!className },
    'card-shadow',
    `card-shadow_${borderType}`,
  );

  return <Box className={cardClasses}>{children}</Box>;
};

export default CardWithShadow;
